export default {
    Pending: 0,
    Paid: 1,
    Cancelled: 2,
    Shipback: 3,
    Decommissioned: 4
  }
  